import OpenInNew from '@mui/icons-material/OpenInNew';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { LinkCrmButton } from '../SidePanel/DocumentSettings/LinkAnAppSection/LinkCrmButton';
import type { CrmEmptyState as CrmEmptyStateValue } from './useCrmEmptyState';

const TRANSLATION_PREFIX = 'editor.variables.crm_empty_state';

type CrmEmptyStateProps = {
  emptyState: NonNullable<CrmEmptyStateValue>;
  contentId: string;
  hasLinkedObjects: boolean;
};

export function CrmEmptyState({ emptyState, contentId, hasLinkedObjects }: CrmEmptyStateProps) {
  const { t } = useTranslation();

  const copy = {
    'not-connected': { title: t(`${TRANSLATION_PREFIX}.not_connected_title`), message: t(`${TRANSLATION_PREFIX}.not_connected_message`) },
    'no-deal': { title: t(`${TRANSLATION_PREFIX}.no_deal_title`), message: t(`${TRANSLATION_PREFIX}.no_deal_message`) },
    'array-empty': { title: t(`${TRANSLATION_PREFIX}.array_empty_title`), message: t(`${TRANSLATION_PREFIX}.array_empty_message`) },
  }[emptyState];

  return (
    <Stack data-testid="crm-empty-state" direction="column" alignItems="center" justifyContent="center" gap={1} sx={{ py: 3, px: 2 }}>
      <Typography variant="subtitle2" textAlign="center">
        {copy.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {copy.message}
      </Typography>
      {emptyState === 'not-connected' && (
        <Box sx={{ pt: 1 }}>
          <Button variant="outlined" color="secondary" endIcon={<OpenInNew />} onClick={() => window.open('/integrations', '_blank')}>
            {t('editor.side_panel.link_an_app.connect_button')}
          </Button>
        </Box>
      )}
      {emptyState === 'no-deal' && (
        <Box sx={{ pt: 1 }}>
          <LinkCrmButton contentId={contentId} hasLinkedObjects={hasLinkedObjects} />
        </Box>
      )}
    </Stack>
  );
}
